/**
 * For use in the footer near the save button - lets the user know that they should check
 * the form for errors (sometimes an inline error may have been scrolled off screen)
 */
angular.module('qkr').directive('footerError', (utils, gettextCatalog) => {
    const linkFn = function(scope, element, attrs, ngModel) {
        // Set default display text
        scope.displayText = gettextCatalog.getString('* Please check the form for errors');

        // Override if provided
        if (scope.errorText) {
            scope.displayText = scope.errorText;
        }

        // Monitor errorObject for changes
        scope.$watch('errorObject', () => {
            if (!utils.isEmpty(scope.errorObject)) {
                scope.displayError = true;
            } else {
                scope.displayError = false;
            }
        }, true);
    };
    return {
        link: linkFn,
        restrict: 'E',
        require: 'ngModel',
        scope: {
            errorObject: '=ngModel',
            errorText: '@'
        },
        template: '<span style="float: left" class="ui-state-error-text footer-error" ng-show="displayError">{{displayText}}</span>'
    };
});



// WEBPACK FOOTER //
// ./src/directives/footerError.js